import axios from "axios";
import { sendMultipartFilePost } from "../utils/multipart-helper";

const requestUpdateSkinBanner = parameter => {
  const formData = new FormData();
  formData.append("jsonSkinBanner", JSON.stringify(parameter.skinBanner));
  formData.append("newFileUrl", JSON.stringify(parameter.newFileUrl));
  formData.append("typeArray", JSON.stringify(parameter.typeArray));
  for (let index = 0; index < parameter.files.length; index++) {
    formData.append("fileList", parameter.files[index]);
  }
  return sendMultipartFilePost(
    `${process.env.VUE_APP_APIURL}/api/app/skin-banner/${parameter.type}/update?foldername=${parameter.foldername}`,
    formData
  );
};

const requestSkinBannerDetail = param => {
  return axios.get(
    `${process.env.VUE_APP_APIURL}/api/app/skin-banner/${param.type}/banner-detail?id=${param.id}`
  );
};

export { requestUpdateSkinBanner, requestSkinBannerDetail };
